// VersionLog.js
// Holder for version change log

// Class Definition
class VersionLog {
  static GetVersionData = () => {
    return [
      {
        version: "0.1",
        changelog: [
          {
            date: new Date(2018, 9, 8),
            changes: [
              'Adicionada coluna de preço unitário nos relatórios de vendas.',
            ],
          },
          {
            date: new Date(2018, 7, 13),
            changes: [
              'Corrigido erro ao tentar gerar relatórios depois de remover uma unidade usada em um pedido',
            ],
          },
          {
            date: new Date(2018, 6, 15),
            changes: [
              'Pedidos e Clientes passam a ser ordenados alfabeticamente sempre.',
              'Adicionado pedido de confirmação ao remover clientes e produtos.',
              'Novo tipo de relatório, agregando todos os pedidos individuais em um arquivo.',
              'Corrigido bug de scroll ao editar unidade de um produto em um pedido.',
            ],
          },
          {
            date: new Date(2018, 6, 11),
            changes: [
              'Versão inicial com definição de produtos, clientes, pedidos e relatórios.',
            ],
          },
        ],
      },
      {
        version: "0.2",
        changelog: [
          {
            date: new Date(2020,1,22),
            changes: [
              'Corrigido erro de aproximação no relatório de resumo de compras.'
            ]
          },
          {
            date: new Date(2020,1,9),
            changes: [
              'Adicionado suporte a ajustes de pedido no relatório de resumo consolidado de pedidos de cliente.',
            ]
          },
          {
            date: new Date(2020,1,6),
            changes: [
              'Adicionado campo de ajuste de pedido, para acertos de produtos já entregues e aplicação de descontos globais.',
              'Opção "Ver somente compras" passa a ser habilitada por padrão nos pedidos.',
              'Corrigido erro de aproximação no valor unitário dos produtos.',
              'Removido campo de assinatura do relatório de vendas.',
            ]
          },
          {
            date: new Date(2019,6,30),
            changes: [
              'Corrigido erro que fazia sistema não armazenar preços de produtos relevantes ao fechar um pedido',
              'Adicionado novo tipo de relatório para consolidar vários pedidos de um único cliente em uma única lista',
            ]
          },
          {
            date: new Date(2018,10,13),
            changes: [
              'Novo sistema de adição rápida preditiva de produtos a um pedido',
              'Adicionado campo de data de entrega em alguns relatórios, de preenchimento manual',
            ]
          }
        ]
      },
      {
        version: "0.2.1",
        changelog: [
          {
            date: new Date(2021,0,27),
            changes: [
              'Dado armazenado no navegador passa a ser comprimido para evitar estourar o espaço disponível',
              'Arquivos de estado salvos passam a ser comprimidos para ocupar menos espaço em disco',
            ]
          },
        ]
      },
      {
        version: "0.2.2",
        changelog: [
          {
            date: new Date(2023,8,27),
            changes: [
              'Novo relatório de preços',
            ]
          },
        ]
      },
      {
        version: "0.2.3",
        changelog: [
          {
            date: new Date(2026,2,21),
            changes: [
              'Suporte a gráficos',
            ]
          },
          {
            date: new Date(2026,2,7),
            changes: [
              'Novo relatório consolidado de compras',
            ]
          },
        ]
      },
    ];
  };
}

// Default Export
export default VersionLog;


// WEBPACK FOOTER //
// ./src/data/VersionLog.js